export default __webpack_public_path__ + "static/media/Live.924a07ab.svg";